import React from "react";
import "./TestWiseDashboard.css";
import images from "../../../../utilities/images/images";
import TooltipCell from "../../../../custom_utilities/ToolTip";

const TestWiseDashboard = ({
  allTests,
  handleStep2,
  setPaperId,
  setPlannerTestId,
  setPapers,
  setSinglePaper,
}) => {
  if (!allTests || allTests.length === 0) {
    return <p>No tests available.</p>;
  }

  return (
    <div className="testwise-list">
      {allTests.map((test, index) => {
        const s = test.student_summary;
        const date = new Date(s.to_be_held_on).toLocaleDateString("en-GB");

        // Dynamic highlight colors
        const perf = s.performance_analysis;

        const badgeColors = perf?.badge_color
          ? perf.badge_color.split(",")
          : ["#FFD", "#FFF"];

        return (
          <div className="testwise-container" key={index}>
            {/* ===== HEADER ===== */}
            <div className="test-meta">
              <div>
                <p className="test-id">
                  <strong>Test ID:</strong> {s.paper_id}
                </p>
                <p className="conducted">
                  <strong>Conducted on:</strong> {date}
                </p>
              </div>

              <div className="actions">
                {/* DOWNLOAD REPORT */}
                <button
                  className="download"
                  onClick={() => {
                    setPaperId(test.paper_id);
                    window.location.href = "/student-report-pdf";
                  }}
                >
                  Download Report
                  <img
                    src={images.mdi_download}
                    alt="arrow"
                    style={{ width: "16px", marginLeft: "8px" }}
                  />
                </button>

                {/* VIEW REPORT */}
                <button
                  className="view-btn"
                  onClick={() => {
                    setPaperId(test.paper_id);
                    setPlannerTestId(test.planner_test_id);
                    setPapers(test.papers);
                    setSinglePaper(test);

                    handleStep2({
                      paper_id: test.paper_id,
                      planner_test_id: test.planner_test_id,
                      papers: test.papers,
                      testDate: test.student_summary.to_be_held_on,
                      singlePaper: test,
                    });
                  }}
                >
                  View Report
                  <img
                    src={images.eye_icon}
                    alt="icon"
                    style={{ width: "16px", marginRight: "8px" }}
                  />
                </button>
              </div>
            </div>

            {/* ===== STATS GRID ===== */}
            <div className="stats-grid">
              <div className="stat-card">
                <p className="label">Overall Marks</p>
                <h2 className="value primary">{s.self_score}</h2>
                <span className="sub">Out of {s.total_marks}</span>
              </div>

              <div className="stat-card">
                <p className="label">Rank</p>
                <h2 className="value brown">{s.rank}</h2>
                <span className="sub">Out of {s.total_student} students</span>
              </div>
<TooltipCell text="Accuracy = (Correct Answers / Total Questions) × 100">
              <div className="stat-card">
                <p className="label">Accuracy</p>
                <h2 className="value">{s.Accuracy}%</h2>
              </div>
</ TooltipCell>
<TooltipCell text="The highest marks scored by the student for this paper">
              <div className="stat-card">
                <p className="label">Highest Marks</p>
                <h2 className="value">{s.highest_marks}</h2>
              </div>
</TooltipCell>
  <TooltipCell text="Average marks scored by all students">
              <div className="stat-card">
                <p className="label">Average Marks</p>
                <h2 className="value">{s.avg_score}</h2>
              </div>
              </TooltipCell>

              {/* ===== DYNAMIC PERCENTAGE–PERCENTILE BOX ===== */}
              <div
                className="highlight-container full-row"
                style={{
                  background: perf?.background,
                  border: `1px solid ${perf?.border}`,
                }}
              >
                {/* Percentage */}
                <TooltipCell text="Percentage = (Marks Obtained / Total Marks) × 100">
                <div className="highlight-section">
                  <p className="label" style={{ color: perf["text-color"] }}>
                    Percentage
                  </p>
                  <h2
                    className="highlight-value"
                    style={{ color: perf["text-color"] }}
                  >
                    {s.percentage}%
                  </h2>
                </div>
</TooltipCell>
                {/* Badge icon with gradient */}
                <div
                  className="highlight-icon"
                  style={{
                    background: `linear-gradient(135deg, ${badgeColors[0]}, ${badgeColors[1]})`,
                    borderRadius: "12px",
                    padding: "8px",
                  }}
                >
                  <img src={images.starpercent_icon} alt="" />
                </div>

                {/* Percentile */}
                 <TooltipCell text="Percentile = ((Total Students - Your Rank) / Total Students) × 100">
                <div className="highlight-section">
                  <p className="label" style={{ color: perf["text-color"] }}>
                    Percentile
                  </p>
                  <h2
                    className="highlight-value"
                    style={{ color: perf["text-color"] }}
                  >
                    {s.percentile}
                  </h2>
                </div>
                </TooltipCell>
              </div>

              {/* SUBJECT LIST */}
              {s.subject_list?.map((sub, i) =>{ console.log("sasi",s.subject_list)
                return(
                <div className="stat-card subject" key={i}>
                    <div className="subject-header">
                  <p className="label">{sub.subject}</p>
                   <span
      className="subject-dot"
      style={{ backgroundColor: sub.color }}
    />
    </div>
                  <h2 className="value" style={{ color: sub.color }}>
                    {sub.score}/{sub.total}
                  </h2>
                </div>
              )})}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TestWiseDashboard;
